const enFunzione = {
  ANAGRAFICA: 100,

  INSERIMENTO_ASSOCIAZIONE: 110,
  MODIFICA_ASSOCIAZIONE: 111,
  CANCELLAZIONE_ASSOCIAZIONE: 112,
  VISUALIZZAZIONE_ASSOCIAZIONE: 113,
  MODIFICA_ASSOCIAZIONE_ASSOCIAZIONE: 114,

  INSERIMENTO_ASSOCIATO: 120,
  MODIFICA_ASSOCIATO: 121,
  CANCELLAZIONE_ASSOCIATO: 122,
  VISUALIZZAZIONE_ASSOCIATO: 123,
  INSERIMENTO_ASSOCIATO_ASSOCIAZIONE: 124,
  MODIFICA_ASSOCIATO_ASSOCIAZIONE: 125,
  CANCELLAZIONE_ASSOCIATO_ASSOCIAZIONE: 126,
  STAMPA_CSAIN_PASS: 127,
  RICHIEDI_RINNOVO_ISCRIZIONE: 128,
  ACCETTA_RINNOVI_ISCRIZIONI: 129,

  EVENTI: 200,
  INSERIMENTO_EVENTO: 210,
  MODIFICA_EVENTO: 211,
  CANCELLAZIONE_EVENTO: 212,
  VISUALIZZAZIONE_EVENTO: 213,
  INSERIMENTO_PRENOTAZIONE_EVENTO: 214,
  CANCELLAZIONE_PRENOTAZIONE_EVENTO: 215,
  ISCRIZIONE_EVENTO_ASSOCIAZIONE: 216,
  INSERIMENTO_EVENTO_ASSOCIAZIONE: 217,
  MODIFICA_EVENTO_ASSOCIAZIONE: 218,
  CANCELLAZIONE_EVENTO_ASSOCIAZIONE: 219,


  HOMEPAGE: 300,
};

const funzioniUtenteAmministrativo = [
  enFunzione.INSERIMENTO_ASSOCIAZIONE,
  enFunzione.MODIFICA_ASSOCIAZIONE,
  enFunzione.MODIFICA_ASSOCIAZIONE_RESPONSABILE,
  enFunzione.CANCELLAZIONE_ASSOCIAZIONE,
  enFunzione.INSERIMENTO_ASSOCIATO,
  enFunzione.MODIFICA_ASSOCIATO,
  enFunzione.CANCELLAZIONE_ASSOCIATO,
  enFunzione.INSERIMENTO_EVENTO,
  enFunzione.MODIFICA_EVENTO,
  enFunzione.CANCELLAZIONE_EVENTO,
  enFunzione.STAMPA_CSAIN_PASS,
  enFunzione.ACCETTA_RINNOVI_ISCRIZIONI,
];


const funzioniUtente = [
  enFunzione.VISUALIZZAZIONE_ASSOCIAZIONE,
  enFunzione.VISUALIZZAZIONE_EVENTO,
  enFunzione.VISUALIZZAZIONE_ASSOCIATO
];


const funzioniUtenteViewer = [
  enFunzione.VISUALIZZAZIONE_ASSOCIAZIONE,
  enFunzione.VISUALIZZAZIONE_EVENTO,
  enFunzione.VISUALIZZAZIONE_ASSOCIATO
];



const funzioniUtenteAssociato = [
  enFunzione.VISUALIZZAZIONE_ASSOCIAZIONE,
  enFunzione.VISUALIZZAZIONE_EVENTO,
  enFunzione.VISUALIZZAZIONE_ASSOCIATO,
  enFunzione.INSERIMENTO_PRENOTAZIONE_EVENTO,
  enFunzione.CANCELLAZIONE_PRENOTAZIONE_EVENTO,
];

const funzioniResponsabileAssociazione = [
  enFunzione.VISUALIZZAZIONE_ASSOCIAZIONE,
  enFunzione.VISUALIZZAZIONE_EVENTO,
  enFunzione.VISUALIZZAZIONE_ASSOCIATO,
  enFunzione.ISCRIZIONE_EVENTO_ASSOCIAZIONE,
  enFunzione.INSERIMENTO_PRENOTAZIONE_EVENTO,
  enFunzione.CANCELLAZIONE_PRENOTAZIONE_EVENTO,
  enFunzione.INSERIMENTO_EVENTO_ASSOCIAZIONE,
  enFunzione.MODIFICA_EVENTO_ASSOCIAZIONE,
  enFunzione.CANCELLAZIONE_EVENTO_ASSOCIAZIONE,
  enFunzione.INSERIMENTO_ASSOCIATO_ASSOCIAZIONE,
  enFunzione.MODIFICA_ASSOCIATO_ASSOCIAZIONE,
  enFunzione.CANCELLAZIONE_ASSOCIATO_ASSOCIAZIONE,
  enFunzione.MODIFICA_ASSOCIAZIONE_ASSOCIAZIONE,
  enFunzione.STAMPA_CSAIN_PASS,
  enFunzione.RICHIEDI_RINNOVO_ISCRIZIONE,

];

const ruolo = {
  ADMIN: 'ADMIN',
  UTENTE_AMMINISTRATIVO: 'UTENTE_AMMINISTRATIVO',
  RESPONSABILE_ASSOCIAZIONE: 'RESPONSABILE_ASSOCIAZIONE',
  ASSOCIATO: 'ASSOCIATO',
  UTENTE: 'UTENTE',
  VIEWER: 'VIEWER'
};

const isAbilitata = (funzione, role) => {
  let allowed = false;

  if (role === ruolo.ADMIN) {
    allowed = true;
  }

  if (role === ruolo.UTENTE_AMMINISTRATIVO) {
    allowed = funzioniUtenteAmministrativo.indexOf(funzione) >= 0;
  }

  if (role === ruolo.RESPONSABILE_ASSOCIAZIONE) {
    allowed = funzioniResponsabileAssociazione.indexOf(funzione) >= 0;
  }

  if (role === ruolo.ASSOCIATO) {
    allowed = funzioniUtenteAssociato.indexOf(funzione) >= 0;
  }

  if (role === ruolo.UTENTE) {
    allowed = funzioniUtente.indexOf(funzione) >= 0;
  }

  if (role === ruolo.VIEWER) {
    allowed = funzioniUtenteViewer.indexOf(funzione) >= 0;
  }
  return allowed;
};

export default {
  enFunzione,
  ruolo,
  isAbilitata,
};